import { create, read, update, remove } from '@/api/rest';

const projectCompetenceSet = {
  index: async (params) =>
    await read('/project-competence-set?' + params.toString()),
  save: async (data) => await create('/project-competence-set/save', data),
  delete: async (id) => await remove(`/project-competence-set/${id}`),
  confirmSetList: async (data) =>
    await update('/project-competence-set/confirm-set-list', data),
};
export default projectCompetenceSet;
